<template>
  <router-view v-slot="{ Component, route }">
    <transition name="care-page">
      <component :is="Component" :key="route.name" />
    </transition>
  </router-view>
</template>

<style>
.care-page-enter-active {
  position: relative;
  z-index: 1;
  transition:
    opacity 0.28s ease-out,
    filter 0.28s ease-out;
}
.care-page-leave-active {
  position: absolute;
  inset: 0;
  width: 100%;
  transition: opacity 0.16s ease-in;
}
.care-page-enter-from {
  opacity: 0;
  filter: blur(2px);
}
.care-page-leave-to {
  opacity: 0;
}
button,
a,
.unit-card,
.card {
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
button:not(:disabled):active {
  transform: scale(0.98);
}
@media (prefers-reduced-motion: reduce) {
  .care-page-enter-active,
  .care-page-leave-active,
  button,
  a,
  .unit-card,
  .card {
    transition: none !important;
  }
}
</style>
